<template>
  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.8433 18.1768C12.61 18.1768 12.3883 18.0834 12.225 17.9201L8.92331 14.6184C8.58497 14.2801 8.58497 13.7201 8.92331 13.3818C9.26164 13.0434 9.82164 13.0434 10.16 13.3818L12.8433 16.0651L18.84 10.0684C19.1783 9.73011 19.7383 9.73011 20.0766 10.0684C20.415 10.4068 20.415 10.9668 20.0766 11.3051L13.4616 17.9201C13.2983 18.0834 13.0766 18.1768 12.8433 18.1768Z"
      fill="white"
    />
  </svg>
</template>
